export default __webpack_public_path__ + "dist/media/projectFolder.220a7c7e.svg";